import $ from 'jquery';
import ctaTypes from './cta.types';
import tdaConfig from 'lib/util/tda.config';
import dealerGxp from './dealer.gxp.cta';
import wwwClickEvent from './www';

var __type = ctaTypes['inventory']; // eslint-disable-line dot-notation
var __defaultUrl = '/' + tdaConfig.site.context_url + '/inventory/';
var __gxpParticipant = BATSiteConfig.gxp && BATSiteConfig.gxp === 'enabled';
var __isWWW = tdaConfig.tda.code === 'WWW';

function __cleanParams(obj) {
  var newObj = obj;
  if (!newObj.series) {
    return {};
  }
  // if multi series, default to first one. works fine when series has no spaces
  newObj.series = newObj.series.split(' ')[0];
  Object.keys(newObj).forEach(function (key) {
    if (!newObj[key]) {
      delete newObj[key];
    }
  });
  Object.keys(newObj).forEach(function (key) {
    newObj[key] = key === 'grade' ? newObj[key] : String(newObj[key]).toLowerCase();
  });
  return newObj;
}

function __buildUrl(params) {
  if ($.isEmptyObject(params)) {
    return __defaultUrl;
  }
  return __defaultUrl + 'results?' + $.param(params);
}

// best possible seriesObj: { series: '', grade: '', year: '' };
export default function invCta(seriesObj, $scope) {
  var $ctaScope = $scope || $('body');
  var $ctas = $("a[data-destination='" + __type + "']", $ctaScope);
  var params = __cleanParams(seriesObj);

  if (!$ctas.length) {
    return;
  }

  $ctas.each(function () {
    var $this = $(this);
    $this.attr('href', __buildUrl(params));
    if (__isWWW) {
      wwwClickEvent($this);
    }
  });

  // GXP CTAs can still get the each treatment above. In fact, they like it.
  if (__gxpParticipant) {
    dealerGxp($ctaScope, $ctas);
  }
};
